import { Flame, CheckCircle2 } from "lucide-react";

export const TIER_ORDER = { hot: 0, warm: 1, standard: 2 };

const STATUS_STYLES = {
  new: "bg-cyan-400/15 text-cyan-300 border-cyan-400/30",
  reviewed: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  archived: "bg-slate-400/15 text-slate-400 border-slate-400/30",
};

export const StatusBadge = ({ status }) => (
  <span className={`text-xs font-semibold uppercase tracking-widest border rounded-full px-3 py-1 ${STATUS_STYLES[status] || STATUS_STYLES.new}`}>
    {status}
  </span>
);

export const PaidBadge = ({ count, total }) => {
  if (!count) return null;
  return (
    <span data-testid="paid-badge" className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest bg-emerald-400/15 text-emerald-300 border border-emerald-400/40 rounded-full px-2.5 py-0.5">
      <CheckCircle2 className="w-3 h-3" /> Paid · ${Number(total).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </span>
  );
};

export const TierBadge = ({ tier, score }) => {
  if (tier === "hot")
    return (
      <span className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest bg-orange-400/15 text-orange-300 border border-orange-400/40 rounded-full px-2.5 py-0.5">
        <Flame className="w-3 h-3" /> Hot · {score}
      </span>
    );
  if (tier === "warm")
    return (
      <span className="inline-flex items-center text-xs font-semibold uppercase tracking-widest bg-amber-400/10 text-amber-300/80 border border-amber-400/25 rounded-full px-2.5 py-0.5">
        Warm · {score}
      </span>
    );
  return null;
};
